export default {"src":"/_next/static/media/gray-plus.2cfa9f20.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};